export default __webpack_public_path__ + "static/media/portifolio.43a83c07.png";